import { useSelector } from 'react-redux';
import { LeadType } from 'testDrive/constants';

export const useCheckServiceable = () => {
  const list = useSelector((state:any) => state?.testDrive?.serviceableData?.list);

  const checkServiceable = ({
    city,
    leadType,
  }: {
    city: string;
    leadType: any;
  }) => {
    if (!city || leadType === LeadType.Oem) return true;
    if (list.includes(city.toLowerCase())) {
      return true;
    } else {
      return true;
    }
  };

  return {
    checkServiceable,
  };
};
